<template>
    <Head title="Viewing Review" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="grid grid-flow-col gap-4">
                <div>
                    <h2 class="text-xl font-semibold leading-tight text-gray-800">
                        Viewing Review #{{ review.id }}
                    </h2>
                </div>
            </div>
        </template>

        <BreadCrumbs :items="navItems"></BreadCrumbs>

        <div class="relative w-full py-2 md:py-12 my-6 overflow-hidden">
            <div class="max-w-lg bg-white shadow-md rounded-lg overflow-hidden mx-auto">
                <div class="py-4 px-6 mt-3">
                    <div class="flex flex-col mb-8">
                        <h2 class="text-gray-700 font-semibold text-2xl tracking-wide mb-2">{{ review.title }}</h2>
                        <blockquote class="flex flex-wrap flex-col bg-white border-l-8 italic border-gray-100 mt-4 px-4 py-3">
                            <div v-html="review.comment"></div>
                            <span class="flex justify-end text-sm font-semibold text-normal pt-2">{{
                                    review.user.name
                                }}</span>
                        </blockquote>
                    </div>
                    <div class="flex justify-center mt-6 mb-6">
                        <ReviewStarRating :modelValue="review.rating"></ReviewStarRating>
                    </div>
                    <div class="bg-grey-100 rounded-lg">
                        <div class="py-4 px-4">
                            <div class="grid grid-cols-2 gap-2" v-if="review.website">
                                <div>
                                    <h4 class="text-lg font-semibold mb-3">{{ review.website.name }}</h4>
                                </div>
                                <div>
                                    <a :href="review.website.url" target="_blank">
                                        <img :src="'/images/logos/tyre-sites/'+logoPath"
                                             class="object-scale-down w-20 float-right"/>
                                    </a>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex flex-col text-sm">
                                    <span class="mb-1"><strong>Review Type:</strong> {{ review.product.type }}</span>
                                    <span class="mb-1"><strong>Reviewed Item:</strong> {{ review.product.name }}</span>
                                    <span class="mb-1"><strong>Reviewed By:</strong> {{ review.user.name }}</span>
                                    <span class="mb-1"><strong>Review Date:</strong> {{ showDate(review.review_date) }}</span>
                                    <span class="mb-1"
                                          v-if="review.referred_from"><strong>Referred From:</strong> {{
                                            review.referred_from
                                        }}</span>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="py-4">
                        <div class="grid grid-flow-col">
                            <div v-if="!review.approved">
                                <admin-link type="button" @click="showReviewAcceptModal" class="!block text-center w-full">Approve</admin-link>
                                <admin-accept-modal v-if="showAcceptModal" @toggle-accept-modal="hideReviewAcceptModal()" :title="`Are you sure you want to approve this review?`" :msg="`Approve this review`">
                                    <admin-link as="button" method="post" class="!block text-center w-full" :href="'/admin/reviews/' + review.id + '/status'" :data="{ approve: 1 }">Approve</admin-link>
                                </admin-accept-modal>
                            </div>
                            <div v-if="!review.approved">
                                <admin-link as="button"
                                            method="post"
                                            class="!block bg-red text-center w-full"
                                            :href="'/admin/reviews/' + review.id + '/status'"
                                            :data="{ approve: 0 }">Reject
                                </admin-link>
                            </div>
                            <div v-else>
                                <admin-link type="button"
                                            class="!block w-full bg-red"
                                            @click="showDeleteModal(review.id)">Delete
                                </admin-link>
                                <admin-delete-modal v-if="deleteModalIdToShow === review.id"
                                                    :msg="modalMessage"
                                                    :type="modalType"
                                                    @toggle-delete-modal="hideDeleteModal()"
                                                    @delete-item="deleteItem(review.id)"></admin-delete-modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <p class="text-placeholder mt-4 max-w-lg mx-auto">
                Something wrong with this review?
                <Link class="underline font-bold" :href="route('admin.reviews.edit', review)">
                    Edit details.
                </Link>
            </p>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import AdminAcceptModal from "@/Components/Admin/AdminAcceptModal";
import AdminDeleteModal from "@/Components/Admin/AdminDeleteModal";
import AdminLink from "@/Components/Admin/AdminLink";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import {Head, useForm, Link} from "@inertiajs/inertia-vue3";
import ReviewStarRating from "@/Components/Reviews/ReviewStarRating";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import dayjs from "dayjs";

export default {
    components:
        {
            BreadCrumbs,
            AdminLink,
            AdminAcceptModal,
            AdminDeleteModal,
            ReviewStarRating,
            Head,
            BreezeAuthenticatedLayout,
            Link
        },
    props:
        {
            review: Object
        },
    data: function()
    {
        return {
            navItems: [
                { title: 'Reviews', path: '/admin/reviews' },
            ],
            showAcceptModal: false,
            deleteModalIdToShow: false,
            modalMessage: 'Are you sure you want to remove this review?',
            modalType: 'Review',
            logoPath: this.review.website !== null ? this.review.website.name + '.png' : null
        }
    },
    mounted() {
        var valueToPush = { };
        valueToPush.title = '#'+ this.review.id;
        valueToPush.path = "/admin/reviews/"+this.review.id+"";

        this.navItems.push(valueToPush);
    },
    methods: {
        showReviewAcceptModal()
        {
            this.showAcceptModal = true;
        },
        hideReviewAcceptModal()
        {
            this.showAcceptModal = false;
        },
        showDeleteModal(id)
        {
            this.deleteModalIdToShow = id;
        },
        hideDeleteModal()
        {
            this.deleteModalIdToShow = false;
        },
        showDate(date)
        {
            return dayjs(date).format('DD-MM-YYYY')
        },
        deleteItem(id)
        {
            this.$inertia.delete('/admin/reviews/'+id);
        }
    }
}
</script>
